function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{display:none;}\n\t.st1{display:inline;fill:none;stroke:#000000;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:currentColor;stroke-width:41.9682;stroke-miterlimit:10;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Guide",
  className: "st0"
}, React.createElement("line", {
  id: "XMLID_2_",
  className: "st1",
  x1: 0,
  y1: 1024.5,
  x2: 2048,
  y2: 1024.5
}), React.createElement("line", {
  id: "XMLID_3_",
  className: "st1",
  x1: 1536,
  y1: 1911.3,
  x2: 512,
  y2: 137.7
}), React.createElement("line", {
  id: "XMLID_4_",
  className: "st1",
  x1: 1536,
  y1: 137.7,
  x2: 512,
  y2: 1911.3
}));

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  id: "_x30__je_2_",
  className: "st2",
  d: "M999.8,678.7c-1.1-176.1,1.2-227.9,4.6-261.8c1.7-17,5.7-29.8,8.2-37.7 c6.7-20.9,11.6-36.3,26.1-46.8c9.3-6.7,27.7-15.1,41.9-8.8c24.9,11.1,24.8,62.1,20.4,90.4c-10.6,68.1-63.7,114.2-85.8,133.5 c-15.4,13.4-15.8,10.9-42.2,32.8c-37.7,31.3-57.4,47.6-75.4,71.7c-10.9,14.5-49.6,69.8-41.3,134.2c1.8,13.9,5.2,37.7,21.5,44.9 c14.2,6.2,32.6-2.7,42.8-12.1c28.2-25.9,28.5-86.5-2.3-123.5c-2.4-2.9-28.4-33.2-69.7-34.3c-59.5-1.6-100.9,58.8-116.2,97.3 c-11.3,28.6-12.2,58.7-10.5,79.1c-153.4-86.5-198.1-114.8-225.9-134.6c-13.9-9.9-23-19.8-28.6-25.9c-14.8-16.2-25.7-28.1-27.6-45.9 c-1.2-11.4,0.6-31.5,13.2-40.7c22-16.1,66.2,9.3,88.6,27.2c53.8,43.1,67.5,112,73.2,140.7c4,20.1,1.7,19.1,7.5,52.9 c8.4,48.3,12.8,73.5,24.7,101.1c7.2,16.6,35.9,77.7,96,102.5c12.9,5.3,35.3,14.3,49.6,3.6c12.5-9.3,13.8-29.6,10.8-43.1 c-8.4-37.4-60.9-67.7-108.3-59.4c-3.8,0.7-42.9,8.2-64.4,43.5c-31,50.9,0.9,116.8,26.7,149.1c23.4,29.3,52.8,44.5,72.7,52.2 c-151,90.6-206.3,120.6-237.2,134.9c-15.5,7.2-28.5,10.2-36.6,12.1c-21.4,4.9-37.2,8.5-53.5,1.3c-10.5-4.6-27.1-16.1-28.9-31.6 c-3.1-27,40.8-53,67.4-63.6c64.1-25.5,130.8-3.3,158.5,5.9c19.4,6.5,17.4,8,49.7,19.6c46.1,16.5,70.2,25.2,100.1,28.5 c18,2,85.3,7.1,136.5-32.8c11-8.6,29.8-23.6,27.7-41.3c-1.9-15.4-18.9-26.7-32.2-30.7c-36.7-11.1-88.9,19.5-105.2,64.8 c-1.3,3.6-14.1,41.4,5.9,77.5c28.9,52.1,102,57.2,142.8,50.5c33.9-5.6,77.8-34.5,76.8-33.8c2.7,176.1,0.8,227.9-2.3,261.8 c-1.6,17-5.5,29.8-7.9,37.7c-6.5,20.9-11.3,36.4-25.7,47c-9.2,6.8-27.5,15.4-41.8,9.2c-25-10.9-25.4-61.8-21.2-90.2 c10-68.2,62.7-114.8,84.6-134.2c15.3-13.5,15.7-11.1,41.9-33.2c37.4-31.6,57-48.1,74.8-72.3c10.7-14.6,48.9-70.2,40.1-134.6 c-1.9-13.8-5.5-37.7-21.9-44.7c-14.3-6.1-32.6,3-42.7,12.4c-28,26.1-27.7,86.7,3.4,123.5c2.5,2.9,28.7,33,70,33.7 c59.6,1.1,100.4-59.7,115.3-98.3c11.3-29.3,11.9-58.6,9.8-79.1c238,131.5,278.7,168.8,227.1,132.6c14,9.8,23.2,19.5,28.8,25.6 c14.9,16,26,27.9,28,45.6c1.3,11.4-0.3,31.5-12.8,40.8c-21.8,16.3-66.3-8.7-88.9-26.4c-54.2-42.6-68.5-111.4-74.4-140.1 c-4.2-20-1.8-19.1-8-52.8c-8.8-48.2-13.5-73.4-25.6-100.9c-7.3-16.6-36.6-77.4-96.9-101.7c-13-5.2-35.4-13.9-49.6-3.2 c-12.4,9.4-13.6,29.7-10.4,43.2c8.8,37.3,61.5,67.1,108.9,58.4c3.8-0.7,42.9-8.5,64-44c30.5-51.2-1.9-116.8-28-148.9 c-20.5-25.3-46.2-40.2-65.4-48.5c151.8-89.3,202.4-117.1,233.4-131.1c15.5-7,28.6-10,36.7-11.7c21.4-4.7,37.2-8.2,53.5-0.9 c10.4,4.7,27,16.4,28.6,31.8c2.9,27.1-41.2,52.6-68,63c-64.3,25-130.8,2.2-158.5-7.3c-19.3-6.6-17.4-8.2-49.5-20 c-46-17-70-25.8-99.8-29.3c-18-2.1-85.2-7.9-136.8,31.6c-11.1,8.5-30,23.4-28,41.1c1.7,15.4,18.7,26.8,31.9,31 c36.6,11.4,89.1-18.7,105.7-63.9c1.3-3.6,14.5-41.2-5.3-77.5c-28.5-52.3-101.5-57.8-142.4-51.7C1043.1,650.7,1016.7,666,999.8,678.7 z"
});

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2000 2000",
    style: {
      enableBackground: "new 0 0 2000 2000"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.4bb6063f.svg";
export { ForwardRef as ReactComponent };